import type { Work } from "@/types/media";

export const works: Work[] = [
  {
    id: "m-1001",
    title: "流浪地球2",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "灾难", "冒险"],
    rating: 8.5,
    popularity: 9860,
    duration: "173分钟",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢"],
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20giant%20frozen%20earth%20engine%20glowing%20warm%20orange%20against%20a%20deep%20blue%20starry%20space%20background%2C%20epic%20scale%2C%20dramatic%20rim%20lighting%2C%20minimalist%20vertical%20composition%2C%20high%20detail%20film%20poster%20illustration&width=600&height=900&seq=poster-liulang-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20panorama%20of%20a%20frozen%20planet%20surface%20with%20massive%20glowing%20engines%20under%20a%20deep%20blue%20night%20sky%2C%20cinematic%20wide%20composition%2C%20atmospheric%20volumetric%20light%2C%20orange%20accents%20against%20cold%20tones%2C%20highly%20detailed%20concept%20art&width=1600&height=900&seq=back-liulang-01&orientation=landscape",
    synopsis:
      "太阳危机迫近，人类启动流浪地球计划，在宇宙中为家园寻找新的轨道。工程师、宇航员与全球联合政府共同面对前所未有的危机，用牺牲与勇气守护文明的延续。",
    tags: ["科幻巨制", "硬核特效", "家国情怀"],
  },
  {
    id: "m-1002",
    title: "满江红",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "古装", "喜剧"],
    rating: 7.8,
    popularity: 8420,
    duration: "159分钟",
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20mystery%20film%20poster%2C%20deep%20crimson%20lanterns%20and%20dark%20courtyard%2C%20silhouette%20of%20a%20warrior%20with%20a%20blade%2C%20ink%20painting%20texture%2C%20dramatic%20vertical%20composition%2C%20rich%20cinematic%20lighting&width=600&height=900&seq=poster-manjiang-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20ancient%20chinese%20palace%20corridor%20at%20night%20lit%20by%20warm%20red%20lanterns%2C%20ink%20wash%20atmosphere%2C%20deep%20shadows%2C%20cinematic%20wide%20shot%2C%20mysterious%20historical%20drama%20concept%20art&width=1600&height=900&seq=back-manjiang-02&orientation=landscape",
    synopsis:
      "南宋绍兴年间，一桩扑朔迷离的命案牵动朝野。小兵与亲兵在重重迷雾中步步追查，层层反转之下，真相关乎忠义与家国。",
    tags: ["悬疑反转", "古装美学", "群像演绎"],
  },
  {
    id: "m-1003",
    title: "消失的她",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 7.1,
    popularity: 7650,
    duration: "121分钟",
    director: "崔睿",
    cast: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    poster:
      "https://readdy.ai/api/search-image?query=psychological%20thriller%20movie%20poster%2C%20lone%20woman%20silhouette%20by%20a%20stormy%20sea%20at%20dusk%2C%20teal%20and%20amber%20color%20palette%2C%20tense%20mood%2C%20minimal%20vertical%20composition%2C%20cinematic%20grain&width=600&height=900&seq=poster-xiaoshi-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=lonely%20dramatic%20seaside%20cliff%20under%20heavy%20storm%20clouds%20at%20dusk%2C%20deep%20teal%20water%20and%20amber%20sky%2C%20cinematic%20wide%20landscape%2C%20suspenseful%20atmosphere%2C%20moody%20film%20concept%20art&width=1600&height=900&seq=back-xiaoshi-03&orientation=landscape",
    synopsis:
      "结婚周年旅行途中，妻子离奇消失，又骤然出现。丈夫在真假难辨的谜局中越陷越深，而真相藏在一场精心设计的博弈背后。",
    tags: ["高能反转", "心理悬疑", "步步惊心"],
  },
  {
    id: "m-1004",
    title: "长安三万里",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["动画", "历史", "剧情"],
    rating: 8.0,
    popularity: 7210,
    duration: "168分钟",
    director: "谢君伟",
    cast: ["杨天翔", "凌振赫", "图特哈蒙"],
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20chinese%20animated%20film%20poster%2C%20a%20poet%20gazing%20at%20a%20vast%20misty%20mountain%20range%20under%20a%20golden%20sunset%2C%20ink%20painting%20style%2C%20vertical%20composition%2C%20warm%20amber%20and%20indigo%20tones%2C%20highly%20detailed&width=600&height=900&seq=poster-changan-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sweeping%20ancient%20chinese%20landscape%20of%20misty%20mountains%20and%20rivers%20at%20golden%20hour%2C%20ink%20painting%20aesthetic%2C%20poetic%20wide%20panorama%2C%20warm%20amber%20light%2C%20serene%20cinematic%20composition&width=1600&height=900&seq=back-changan-04&orientation=landscape",
    synopsis:
      "大唐盛世之下，诗人与挚友在数十年间聚散离合。从长安到边塞，一首首流传千古的诗篇，见证了一个时代的辉煌与苍凉。",
    tags: ["国风动画", "诗意叙事", "大唐风采"],
  },
  {
    id: "m-1005",
    title: "封神第一部：朝歌风云",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["奇幻", "动作", "古装"],
    rating: 7.7,
    popularity: 6890,
    duration: "148分钟",
    director: "乌尔善",
    cast: ["费翔", "李雪健", "黄渤", "夏雨"],
    poster:
      "https://readdy.ai/api/search-image?query=majestic%20ancient%20chinese%20fantasy%20movie%20poster%2C%20armored%20warrior%20before%20a%20colossal%20bronze%20palace%2C%20dramatic%20golden%20lightning%2C%20deep%20crimson%20and%20bronze%20palette%2C%20epic%20vertical%20composition&width=600&height=900&seq=poster-fengshen-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20fantasy%20battlefield%20before%20a%20vast%20bronze%20dynasty%20palace%2C%20stormy%20sky%20with%20golden%20light%2C%20cinematic%20wide%20shot%2C%20bronze%20and%20crimson%20tones%2C%20highly%20detailed%20concept%20art&width=1600&height=900&seq=back-fengshen-05&orientation=landscape",
    synopsis:
      "商王殷寿勾结狐妖，暴虐无道。质子姬发在忠诚与良知之间挣扎，逐渐认清真相，踏上改写命运的征途。",
    tags: ["神话史诗", "大场面", "东方奇幻"],
  },
  {
    id: "m-1006",
    title: "孤注一掷",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    rating: 6.9,
    popularity: 6580,
    duration: "130分钟",
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅", "王传君"],
    poster:
      "https://readdy.ai/api/search-image?query=tense%20crime%20drama%20movie%20poster%2C%20a%20young%20man%20trapped%20behind%20glowing%20digital%20screens%20in%20a%20dark%20room%2C%20cold%20cyan%20and%20amber%20accents%2C%20vertical%20composition%2C%20cinematic%20lighting&width=600&height=900&seq=poster-guzhu-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dark%20high%20tech%20fraud%20call%20center%20with%20rows%20of%20glowing%20monitors%2C%20moody%20cold%20blue%20lighting%20with%20amber%20highlights%2C%20cinematic%20wide%20composition%2C%20tense%20thriller%20atmosphere&width=1600&height=900&seq=back-guzhu-06&orientation=landscape",
    synopsis:
      "程序员与模特被高薪诱惑骗入境外诈骗集团，在绝境中寻找逃生之路。一场关于欲望、陷阱与救赎的现实题材故事。",
    tags: ["现实题材", "反诈警示", "紧张刺激"],
  },
  {
    id: "m-1007",
    title: "热辣滚烫",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "剧情"],
    rating: 7.4,
    popularity: 6320,
    duration: "129分钟",
    director: "贾玲",
    cast: ["贾玲", "雷佳音", "张小斐", "杨紫"],
    poster:
      "https://readdy.ai/api/search-image?query=uplifting%20sports%20drama%20movie%20poster%2C%20a%20boxer%20standing%20determined%20in%20a%20gym%20lit%20by%20warm%20amber%20light%2C%20hopeful%20mood%2C%20vertical%20composition%2C%20cinematic%20contrast&width=600&height=900&seq=poster-rela-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=warm%20atmospheric%20boxing%20gym%20interior%20with%20dusty%20sunlight%20streaming%20through%20windows%2C%20amber%20and%20charcoal%20tones%2C%20cinematic%20wide%20shot%2C%20inspiring%20mood&width=1600&height=900&seq=back-rela-07&orientation=landscape",
    synopsis:
      "一个习惯了讨好别人的女孩，在人生谷底选择为自己而战。拳台上的每一次挥拳，都是与过去和解、重新出发的宣言。",
    tags: ["励志", "热血", "自我成长"],
  },
  {
    id: "m-1008",
    title: "沙丘2",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.3,
    popularity: 6980,
    duration: "166分钟",
    director: "丹尼斯·维伦纽瓦",
    cast: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
    poster:
      "https://readdy.ai/api/search-image?query=epic%20desert%20sci-fi%20movie%20poster%2C%20a%20lone%20figure%20in%20a%20cloak%20before%20colossal%20sand%20dunes%20under%20a%20burning%20sun%2C%20orange%20and%20ochre%20palette%2C%20minimalist%20vertical%20composition&width=600&height=900&seq=poster-dune-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20alien%20desert%20world%20with%20towering%20sand%20dunes%20under%20a%20hazy%20burning%20sky%2C%20epic%20cinematic%20wide%20composition%2C%20warm%20ochre%20and%20amber%20tones%2C%20majestic%20atmosphere&width=1600&height=900&seq=back-dune-08&orientation=landscape",
    synopsis:
      "保罗与弗雷曼人并肩作战，在复仇与命运之间做出抉择。广袤沙丘之下，一场牵动宇宙格局的战争即将爆发。",
    tags: ["科幻史诗", "视觉奇观", "宇宙战争"],
  },
  {
    id: "m-1009",
    title: "奥本海默",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["传记", "剧情", "历史"],
    rating: 8.6,
    popularity: 6120,
    duration: "180分钟",
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    poster:
      "https://readdy.ai/api/search-image?query=serious%20historical%20biography%20film%20poster%2C%20portrait%20of%20a%20scientist%20lit%20by%20a%20glowing%20orange%20explosion%2C%20charcoal%20and%20amber%20palette%2C%20dramatic%20vertical%20composition%2C%20cinematic%20grain&width=600&height=900&seq=poster-oppen-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=atmospheric%20dark%20laboratory%20with%20a%20distant%20glowing%20orange%20mushroom%20cloud%20on%20the%20horizon%2C%20charcoal%20and%20amber%20tones%2C%20cinematic%20wide%20composition%2C%20solemn%20mood&width=1600&height=900&seq=back-oppen-09&orientation=landscape",
    synopsis:
      "一位物理学家在历史的十字路口，亲手推动了改变世界的力量。荣耀与良知、科学与道德，在聚光灯下激烈碰撞。",
    tags: ["人物传记", "历史厚重", "表演封神"],
  },
  {
    id: "tv-2001",
    title: "狂飙",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    rating: 8.8,
    popularity: 9720,
    duration: "全39集",
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    poster:
      "https://readdy.ai/api/search-image?query=gritty%20crime%20drama%20tv%20poster%2C%20two%20men%20facing%20each%20other%20in%20a%20dim%20city%20alley%20at%20night%2C%20sepia%20and%20amber%20tones%2C%20vertical%20composition%2C%20cinematic%20tension&width=600&height=900&seq=poster-kuangbiao-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20southern%20chinese%20city%20street%20at%20night%20with%20warm%20streetlights%20and%20wet%20asphalt%2C%20sepia%20and%20amber%20tones%2C%20cinematic%20wide%20shot%2C%20gritty%20crime%20drama%20atmosphere&width=1600&height=900&seq=back-kuangbiao-11&orientation=landscape",
    synopsis:
      "一名基层民警与一个鱼贩子，在二十年间的命运纠葛中走向对立。正义与欲望的较量，勾勒出一幅时代群像。",
    tags: ["扫黑题材", "年度剧王", "群像大戏"],
  },
  {
    id: "tv-2002",
    title: "漫长的季节",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "剧情", "年代"],
    rating: 9.2,
    popularity: 9150,
    duration: "全12集",
    director: "辛爽",
    cast: ["范伟", "秦昊", "陈明昊", "李庚希"],
    poster:
      "https://readdy.ai/api/search-image?query=northern%20chinese%20industrial%20town%20mystery%20drama%20poster%2C%20a%20middle%20aged%20man%20by%20autumn%20railway%20tracks%2C%20rust%20and%20amber%20palette%2C%20melancholic%20vertical%20composition%2C%20cinematic&width=600&height=900&seq=poster-manc-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=autumn%20northern%20chinese%20industrial%20town%20with%20rusting%20factories%20and%20falling%20golden%20leaves%2C%20warm%20melancholic%20amber%20tones%2C%20cinematic%20wide%20composition%2C%20nostalgic%20mood&width=1600&height=900&seq=back-manc-12&orientation=landscape",
    synopsis:
      "一桩尘封多年的出租车套牌案，牵出三个老男人跨越二十年的执念。在季节轮回中，他们终于与往事和解。",
    tags: ["高分神作", "年代质感", "悬疑佳作"],
  },
  {
    id: "tv-2003",
    title: "三体",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "剧情"],
    rating: 8.6,
    popularity: 8730,
    duration: "全30集",
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    poster:
      "https://readdy.ai/api/search-image?query=hard%20sci-fi%20tv%20poster%20with%20a%20giant%20alien%20eye%20reflecting%20a%20starfield%2C%20deep%20indigo%20and%20cyan%20tones%2C%20minimal%20vertical%20composition%2C%20mysterious%20cinematic%20atmosphere&width=600&height=900&seq=poster-santi-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cosmic%20deep%20space%20scene%20with%20a%20lone%20tiny%20earth%20and%20vast%20swirling%20nebula%2C%20deep%20indigo%20and%20teal%20tones%2C%20cinematic%20wide%20composition%2C%20awe%20inspiring%20sci-fi%20atmosphere&width=1600&height=900&seq=back-santi-13&orientation=landscape",
    synopsis:
      "一场诡异的科学家连环死亡事件，把纳米材料专家卷入一个跨越星际的谜团。人类文明与宇宙法则的第一次对话，就此展开。",
    tags: ["硬核科幻", "改编自名著", "格局宏大"],
  },
  {
    id: "tv-2004",
    title: "繁花",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "都市", "年代"],
    rating: 8.2,
    popularity: 7980,
    duration: "全30集",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20shanghai%20retro%20era%20drama%20poster%2C%20stylish%20man%20in%20a%20trench%20coat%20under%20warm%20neon%20lights%2C%20amber%20and%20crimson%20tones%2C%20vertical%20composition%2C%20cinematic%20sheen&width=600&height=900&seq=poster-fanhua-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=1990s%20shanghai%20street%20at%20dusk%20with%20warm%20neon%20signs%20and%20wet%20reflections%2C%20golden%20amber%20and%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20nostalgic%20elegance&width=1600&height=900&seq=back-fanhua-14&orientation=landscape",
    synopsis:
      "上世纪九十年代的上海，小人物阿宝在时代浪潮中打拼成一方人物。繁华背后，是人情冷暖与命运的浮沉。",
    tags: ["大师执导", "年代风情", "视觉盛宴"],
  },
  {
    id: "tv-2005",
    title: "苍兰诀",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "奇幻", "爱情"],
    rating: 7.9,
    popularity: 7460,
    duration: "全36集",
    director: "伊峥",
    cast: ["虞书欣", "王鹤棣", "张凌赫", "郭晓婷"],
    poster:
      "https://readdy.ai/api/search-image?query=fantasy%20ancient%20chinese%20romance%20drama%20poster%2C%20celestial%20maiden%20and%20demon%20lord%20amid%20floating%20lanterns%2C%20soft%20misty%20pink%20and%20gold%20tones%2C%20dreamy%20vertical%20composition&width=600&height=900&seq=poster-canglan-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dreamy%20celestial%20ancient%20chinese%20fantasy%20realm%20with%20floating%20palaces%20and%20misty%20mountains%2C%20soft%20pink%20and%20gold%20tones%2C%20cinematic%20wide%20composition%2C%20ethereal%20romantic%20atmosphere&width=1600&height=900&seq=back-canglan-15&orientation=landscape",
    synopsis:
      "小兰花与月族魔尊意外互换身体，一段跨越仙魔两界的姻缘就此纠缠。爱恨交织之间，宿命悄然改写。",
    tags: ["仙侠爆款", "高甜虐恋", "东方美学"],
  },
  {
    id: "tv-2006",
    title: "隐秘的角落",
    type: "tv",
    year: 2020,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.8,
    popularity: 7020,
    duration: "全12集",
    director: "辛爽",
    cast: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    poster:
      "https://readdy.ai/api/search-image?query=tense%20coastal%20town%20thriller%20poster%2C%20three%20children%20silhouette%20on%20a%20rocky%20shore%20under%20overcast%20sky%2C%20cool%20teal%20and%20muted%20amber%20tones%2C%20vertical%20composition&width=600&height=900&seq=poster-yinmi-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20coastal%20town%20shore%20with%20dark%20rocks%20and%20grey%20sea%20under%20heavy%20clouds%2C%20cool%20teal%20and%20muted%20tones%2C%20cinematic%20wide%20composition%2C%20suspenseful%20atmosphere&width=1600&height=900&seq=back-yinmi-16&orientation=landscape",
    synopsis:
      "三个孩子在景区意外拍到一场谋杀，从此被卷入成人的危险世界。天真的童年与幽暗的人性，在此悄然碰撞。",
    tags: ["悬疑标杆", "短剧精品", "社会派"],
  },
  {
    id: "tv-2007",
    title: "人世间",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["年代", "家庭", "剧情"],
    rating: 8.4,
    popularity: 6890,
    duration: "全58集",
    director: "李路",
    cast: ["雷佳音", "辛柏青", "宋佳", "殷桃"],
    poster:
      "https://readdy.ai/api/search-image?query=warm%20family%20saga%20period%20drama%20poster%2C%20family%20portrait%20before%20an%20old%20brick%20housing%20block%2C%20faded%20warm%20amber%20and%20olive%20tones%2C%20vertical%20composition&width=600&height=900&seq=poster-renshi-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=northern%20chinese%20old%20residential%20neighborhood%20in%20the%201980s%20with%20brick%20buildings%20and%20bare%20trees%2C%20faded%20warm%20amber%20and%20olive%20tones%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=back-renshi-17&orientation=landscape",
    synopsis:
      "周家三兄妹在近五十年时代变迁中各自经历人生起伏。平凡家庭的悲欢离合，折射出大时代的温度与重量。",
    tags: ["年代史诗", "平凡伟大", "催泪佳作"],
  },
  {
    id: "va-3001",
    title: "乘风破浪的姐姐",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "真人秀"],
    rating: 7.6,
    popularity: 8360,
    duration: "全12期",
    director: "芒果TV",
    cast: ["宁静", "那英", "张雨绮", "万茜"],
    poster:
      "https://readdy.ai/api/search-image?query=vibrant%20stage%20reality%20show%20poster%2C%20confident%20women%20performers%20under%20warm%20spotlights%2C%20glamorous%20amber%20and%20magenta%20accents%2C%20dynamic%20vertical%20composition&width=600&height=900&seq=poster-chengfeng-21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dazzling%20concert%20stage%20with%20warm%20spotlights%20and%20glowing%20led%20screens%2C%20energetic%20amber%20and%20pink%20accents%2C%20cinematic%20wide%20composition%2C%20vibrant%20atmosphere&width=1600&height=900&seq=back-chengfeng-21&orientation=landscape",
    synopsis:
      "一群在不同领域闪耀的姐姐再度集结舞台，用实力与热爱重新定义年龄。每一次公演，都是对自我的全新挑战。",
    tags: ["女性成长", "舞台竞演", "热度爆棚"],
  },
  {
    id: "va-3002",
    title: "披荆斩棘",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    rating: 7.3,
    popularity: 7640,
    duration: "全13期",
    director: "芒果TV",
    cast: ["胡彦斌", "苏有朋", "陆毅", "信"],
    poster:
      "https://readdy.ai/api/search-image?query=energetic%20male%20stage%20competition%20show%20poster%2C%20silhouettes%20of%20performers%20before%20blazing%20orange%20stage%20lights%2C%20bold%20dynamic%20vertical%20composition%2C%20cinematic%20contrast&width=600&height=900&seq=poster-pijing-22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=powerful%20concert%20stage%20with%20blazing%20orange%20and%20amber%20lights%20and%20smoke%2C%20high%20energy%20atmosphere%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=back-pijing-22&orientation=landscape",
    synopsis:
      "来自不同领域的哥哥们组成竞演战队，在音乐舞台上不断突破。汗水、友情与热爱，构成一档热血真人秀。",
    tags: ["哥哥竞演", "热血舞台", "全明星阵容"],
  },
  {
    id: "va-3003",
    title: "奔跑吧",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["户外", "真人秀"],
    rating: 7.0,
    popularity: 7210,
    duration: "全12期",
    director: "浙江卫视",
    cast: ["李晨", "杨颖", "郑恺", "沙溢"],
    poster:
      "https://readdy.ai/api/search-image?query=fun%20outdoor%20reality%20show%20poster%2C%20energetic%20group%20running%20on%20a%20colorful%20city%20street%2C%20bright%20warm%20amber%20and%20teal%20accents%2C%20playful%20vertical%20composition&width=600&height=900&seq=poster-benpao-23&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sunny%20city%20street%20scene%20with%20bright%20colorful%20decorations%20and%20motion%20blur%2C%20warm%20amber%20and%20teal%20accents%2C%20cinematic%20wide%20composition%2C%20playful%20upbeat%20atmosphere&width=1600&height=900&seq=back-benpao-23&orientation=landscape",
    synopsis:
      "跑男团在各地展开趣味十足的挑战任务，用体力与智慧一决高下。轻松欢快的户外竞技，带来满满笑声。",
    tags: ["跑男团", "户外竞技", "合家欢"],
  },
  {
    id: "va-3004",
    title: "极限挑战",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["户外", "真人秀"],
    rating: 7.2,
    popularity: 6980,
    duration: "全12期",
    director: "东方卫视",
    cast: ["黄渤", "孙红雷", "王迅", "张艺兴"],
    poster:
      "https://readdy.ai/api/search-image?query=adventurous%20outdoor%20reality%20show%20poster%2C%20men%20exploring%20a%20rugged%20mountain%20trail%20at%20golden%20hour%2C%20warm%20amber%20and%20slate%20tones%2C%20dynamic%20vertical%20composition&width=600&height=900&seq=poster-jixian-24&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sweeping%20mountain%20landscape%20at%20golden%20hour%20with%20winding%20trails%2C%20warm%20amber%20and%20slate%20tones%2C%20cinematic%20wide%20composition%2C%20adventurous%20atmosphere&width=1600&height=900&seq=back-jixian-24&orientation=landscape",
    synopsis:
      "极限男人帮深入不同城市与荒野，完成一个又一个不可能的任务。智慧与默契的较量，笑料与感动齐飞。",
    tags: ["男人帮", "烧脑任务", "爆笑不断"],
  },
  {
    id: "va-3005",
    title: "歌手",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    rating: 7.8,
    popularity: 7820,
    duration: "全13期",
    director: "湖南卫视",
    cast: ["那英", "周深", "林俊杰", "谭维维"],
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20music%20competition%20show%20poster%2C%20a%20singer%20before%20a%20microphone%20under%20warm%20golden%20stage%20lights%2C%20deep%20amber%20and%20charcoal%20tones%2C%20vertical%20composition&width=600&height=900&seq=poster-geshou-25&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dramatic%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20smoke%2C%20deep%20amber%20and%20charcoal%20tones%2C%20cinematic%20wide%20composition%2C%20emotional%20atmosphere&width=1600&height=900&seq=back-geshou-25&orientation=landscape",
    synopsis:
      "顶尖歌手同台竞演，用最纯粹的声音一较高下。每一期都是一场听觉盛宴，唱功与情感的双重较量。",
    tags: ["顶级唱将", "现场竞演", "金曲不断"],
  },
];